import { createContext, PropsWithChildren } from 'react';
import { useEntitiesListManager } from '@/providers/EntitiesListContextProvider/EntitiesListContext.hooks';
import { IEntitiesListContext } from '@/providers/EntitiesListContextProvider/EntitiesListContext.types';

export const EntitiesListContext = createContext<Partial<IEntitiesListContext>>({});

export const EntitiesListProvider = ({ children }: PropsWithChildren) => {
  const {
    entities,
    isEntitiesListLoading,
    entitiesListError,
    monitoringAndAlertingEntitiesManagedByTypes,
    monitoredAndRatedEntitiesManagedByTypes,
    getEntityValueByDisplayName,
    getDisplayNameByEntityValue,
    getStatusByEntityValue,
    checkIsEntityValueRequestedType,
  } = useEntitiesListManager();

  const VALUE: IEntitiesListContext = {
    entities,
    isEntitiesListLoading,
    entitiesListError: entitiesListError,
    monitoringAndAlertingEntitiesManagedByTypes,
    monitoredAndRatedEntitiesManagedByTypes,
    getEntityValueByDisplayName,
    getDisplayNameByEntityValue,
    getStatusByEntityValue,
    checkIsEntityValueRequestedType,
  };

  return <EntitiesListContext.Provider value={VALUE}>{children}</EntitiesListContext.Provider>;
};
